import { render } from "./SupplierCategories.vue?vue&type=template&id=51eee8b5&scoped=true"
import script from "./SupplierCategories.vue?vue&type=script&lang=js"
export * from "./SupplierCategories.vue?vue&type=script&lang=js"

import "./SupplierCategories.vue?vue&type=style&index=0&id=51eee8b5&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51eee8b5"]])

export default __exports__